import { render, staticRenderFns } from "./organizeDetail.vue?vue&type=template&id=6025c1ea&scoped=true&"
import script from "./organizeDetail.vue?vue&type=script&lang=js&"
export * from "./organizeDetail.vue?vue&type=script&lang=js&"
import style0 from "./organizeDetail.vue?vue&type=style&index=0&id=6025c1ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025c1ea",
  null
  
)

export default component.exports